import { t } from "../../i18n/translations";

import styles from "./styles.module.scss";

interface HintMessageProps {
  hint: string | null;
}

export function HintMessage({ hint }: HintMessageProps) {
  const text = hint ? t(hint) : null;
  const visible = !!text;

  return (
    <div
      className={`${styles.root} ${visible ? styles.visible : styles.hidden}`}
    >
      {text}
    </div>
  );
}
